import React, { useRef } from 'react'

// Styles
import { ProductDownloadLogos, ProductDownloadRaisedBox } from './style'

// Components
import Button from '../button'
import Typography from '../typography'

// Helpers
import { navigate } from 'gatsby'
import ImgUtil from '../../../utils/img.utils'
import { internalLinkHandler } from '../../../utils/link.utils'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import WrapperImage from '../wrapperImage'

const ProductDownload = (props: any) => {
  if (props.data) {
    const downloadRef = useRef<HTMLAnchorElement>(null)

    const { data } = props
    const finePrint = data.finePrint ? data.finePrint : ''
    const eyebrow = data.tileEyebrow ? data.tileEyebrow : ''
    const logosIntro = data.logosIntro ? data.logosIntro : ''
    const logosOutro = data.logosOutro ? data.logosOutro : ''
    const progressPage = data.progressPage ? data.progressPage : ''
    let progressPageSlug = ''
    let fileDownload = ''
    let fileName = ''
    let ctaText = ''

    if (progressPage && progressPage.slug) {
      const slug = progressPage.slug
      if (slug.charAt(0) === '/') {
        progressPageSlug = slug
      } else {
        progressPageSlug = `/${slug}`
      }
    }

    // externalDownload takes precedence over fileDownload
    if (data.externalDownload) {
      fileDownload = data.externalDownload.externalUrl
        ? data.externalDownload.externalUrl
        : internalLinkHandler(data.externalDownload.internalLink)
      ctaText = data.externalDownload.text
    } else if (data.fileDownload && data.fileDownload.file) {
      if (data.fileDownload.file.url) {
        fileDownload = data.fileDownload.file.url
      }
      if (data.fileDownload.file.fileName) {
        fileName = data.fileDownload.file.fileName
      }
      ctaText = data.ctaText
    }

    const generateLogos = () => {
      if (data.products) {
        return data.products.map((product: any, i: number) => {
          const productName = product.text ? product.text : ''
          const productLogo =
            product.tileMedia &&
            product.tileMedia.image &&
            product.tileMedia.image.file &&
            product.tileMedia.image.file.url
              ? product.tileMedia.image.file.url
              : 'UiPath Logo'
          const productLogoAlt =
            product.tileMedia && product.tileMedia.altText
              ? product.tileMedia.altText
              : 'UiPath Logo'

          return (
            <React.Fragment key={`product-logo--${i}`}>
              <div className="ProductDownload__Download-Product-Item">
                <WrapperImage
                  className="ProductDownload__Download-Product-Logo"
                  src={ImgUtil.getResizedImageUrl(productLogo, `width=250`)}
                  alt={productLogoAlt}
                  threshold={650}
                />
                <Typography type="bodyXS" className="ProductDownload__Product-Description">
                  {productName}
                </Typography>
              </div>
              {i !== data.products.length - 1 && (
                <WrapperImage
                  className="ProductDownload__Plus-Icon"
                  src={ImgUtil.getResizedImageUrl(
                    'https://images.ctfassets.net/5965pury2lcm/1H6PRosfekEQh4MEhwvk0K/cab8d5080915e46049049a96cbf43169/plus-icon.png',
                    `width=50`
                  )}
                  alt="Plus Icon"
                  threshold={650}
                />
              )}
            </React.Fragment>
          )
        })
      }
    }

    const generateCustomerLogos = () => {
      if (data.logos) {
        return data.logos.map((logo: any, i: number) => {
          const altText = logo.altText ? logo.altText : 'Customer logo'
          const image =
            logo.image && logo.image.file && logo.image.file.url ? logo.image.file.url : '/'

          return (
            <WrapperImage
              src={ImgUtil.getResizedImageUrl(image, `width=200`)}
              alt={altText}
              key={`Customer-Logo--${i}`}
              className="ProductDownload__Customer-Logo-File"
              threshold={650}
            />
          )
        })
      }
    }

    const handleButtonClick = (event: any) => {
      event?.preventDefault()
      if (downloadRef && downloadRef.current) {
        downloadRef.current.click()
        if (progressPageSlug) {
          navigate(progressPageSlug)
        }
      }
    }

    return (
      <>
        <ProductDownloadRaisedBox data-cy="ProductDownload">
          {eyebrow && (
            <Typography type="captionAlt" className="ProductDownload__Download-Eyebrow">
              {eyebrow}
            </Typography>
          )}
          <div className="ProductDownload__Gray-Line"></div>
          <div className="ProductDownload__Download-Products">{generateLogos()}</div>
          <div className="ProductDownload__Gray-Line"></div>
          {progressPage && fileDownload && (
            <>
              <a
                ref={downloadRef}
                href={fileDownload}
                download={fileName}
                data-cy="ProductDownload-File"></a>
              <Button
                icon={true}
                iconFile={
                  <WrapperImage
                    className="ProductDownload__Button-Icon"
                    src="https://images.ctfassets.net/5965pury2lcm/HObHSPkCpjalZDiwe9KvW/1fd5e2db19617036d977d3eb52e050ee/Download-Icon.png"
                    alt="Download icon"
                    threshold={650}
                  />
                }
                className="ProductDownload__Download-Button"
                text={ctaText}
                size="medium"
                arrowOrientation="right"
                type="primary"
                theme="light"
                clickHandler={handleButtonClick}
              />
            </>
          )}
          {finePrint && (
            <Typography type="caption" className="ProductDownload__Disclaimer">
              {renderRichText(finePrint)}
            </Typography>
          )}
        </ProductDownloadRaisedBox>
        <ProductDownloadLogos>
          <Typography type="caption" className="ProductDownload__Logos-Text">
            {logosIntro}
          </Typography>
          <div className="ProductDownload__Logos-Container">{generateCustomerLogos()}</div>
          <Typography type="caption" className="ProductDownload__Logos-Text">
            {logosOutro}
          </Typography>
        </ProductDownloadLogos>
      </>
    )
  }
  return null
}

export default ProductDownload
